import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiselectAutocompleteComponent } from './multiselect-autocomplete.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';

@NgModule({
    declarations: [MultiselectAutocompleteComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatFormFieldModule,
        FlexLayoutModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        CustomerPrivacyModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [MultiselectAutocompleteComponent],
})
export class MultiselectAutocompleteModule {}
